const REGISTER_FORM = {
  title: 'Cadastre-se para dar o primeiro passo na nossa parceria',
  alreadyHaveAccount: 'Já tem uma conta de parceiro?',
  login: 'Faça login',
  fillTheInfoCarefully: 'Preencha as informações com atenção e corretamente.',
  proceed: 'Continuar',
  back: 'Voltar',
  confirm: 'Confirmar',
  personal: {
    agreeToTheTerms: 'Ao iniciar o cadastro você esta concordando com nossa',
    privacyPolicy: 'Política de Privacidade',
    serviceTerms: 'Termos de Serviço',
    beginRegister: 'Iniciar cadastro',
    labels: {
      name: 'Nome completo',
      cellphone: 'Celular com whatsapp',
    },
    placeholders: {
      name: 'Ex. José da Silva',
      cellphone: 'Ex. (00) 00000-0000',
    },
    tip: {
      name: 'Pessoa responsável legalmente pela loja.',
      cellphone:
        'Nosso canal de comunicação é WhatsApp, por isso digite o seu número principal.',
    },
    messages: {
      cellphone: {
        notValidatedOrExpired: {
          text: 'Validação do telefone expirada',
          fixHere: 'ajuste aqui',
        },
        generic: {
          text: 'Tivemos um problema ao validar seu telefone, por favor, tente novamente',
          here: 'aqui',
        },
      },
    },
    acessibility: {
      beginRegister: 'Seguir para preenchimento de informações da loja.',
    },
  },
  store: {
    labels: {
      document: 'CNPJ',
      tradingName: 'Nome da loja',
      address: 'Endereço com o número da sua loja',
      addressWithoutNumber: 'Endereço da sua loja',
      number: 'Número',
      complement: 'Complemento (opcional)',
      zipcode: 'CEP',
      phone: 'Telefone da loja',
    },
    placeholders: {
      document: 'Ex. 00.000.000/0000-00',
      tradingName: 'Ex. Bar do José',
      address: 'Ex. Rua do Zé, 123',
      complement: 'Ex. Loja 02',
      zipcode: 'Ex. 00000-000',
      phone: 'Ex. (00) 0000-0000',
    },
    tip: {
      document: 'O CNPJ não poderá ser editado no futuro. Digite corretamente.',
      phone: 'Telefone para clientes entrarem em contato com as lojas.',
    },
    messages: {
      number: 'Endereço sem o número da loja',
    },
    acessibility: {
      address: 'Escrever o nome da rua ou avenida e depois o número',
      backButton: 'Para preenchimento de informações da loja.',
      nextButton:
        'Seguir para preenchimento de informações da estrutura da loja.',
    },
  },
  structure: {
    labels: {
      invoice: 'Sua loja emite cupom fiscal?',
      refrigerators: 'Qual a quantidade de refrigeradores na sua loja?',
      coldChamber: 'Sua loja possui câmara fria?',
      deliveryService: 'Sua loja possui serviço de entrega?',
    },
    acessibility: {
      backButton: 'Para preenchimento de informações da loja.',
      nextButton: 'Seguir para preenchimento de informações de acesso.',
    },
  },
  phoneValidation: {
    resendCodeText: 'Novo código enviado com sucesso!',
    title: 'Confirme o seu celular para continuar',
    text: 'Enviamos um código por WhatsApp para:',
    editNumber: 'Número incorreto?',
    resendCodeIn: 'Reenviar o código em',
    clickToResendCode: 'Clique aqui para reenviar o código',
    confirm: 'Confirmar',
    acessibility: {
      editNumber: 'Editar número de telefone com WhatsApp',
      inputs: 'Digite o código enviado pelo WhatsApp',
      backButton: 'Para preenchimento de informações da estrutura da loja.',
      nextButton: 'Seguir para criar acesso.',
    },
  },
  editPhoneModal: {
    submit: 'Alterar',
    acessibility: {
      backButton: 'Para tela de confirmação de WhatsApp.',
      submit: 'Confirmar alteração de telefone com WhatsApp.',
    },
  },
  access: {
    labels: {
      email: 'Email de acesso',
      password: 'Senha',
      passwordConfirmation: 'Confirme sua senha',
    },
    placeholders: {
      email: 'Ex. maria@email.com.br',
      password: 'Digite sua senha',
      passwordConfirmation: 'Digite sua senha',
    },
    tip: {
      email:
        'E-mail para receber informativos e logar na plataforma do Seu Zé.',
    },
    passwordInfo:
      'A senha deve conter no mínimo 10 caracteres com letras, números e caracteres especiais',
    allowNewsletter: {
      wantToReceiveNewsAndPromotions: 'Quero receber novidades e promoções do',
      ze: 'Zé Delivery',
      per: 'por e-mail, celular, mensagem de texto, por correio ou telefone.',
    },
    finishRegister: 'Finalizar cadastro',
    acessibility: {
      password: 'Deve conter no mínimo 8 caracteres com letras e números',
      passwordConfirmation: 'Mesma senha do campo anterior',
      backButton: 'Para preenchimento de informações da estrutura da loja.',
      finishRegister: 'Seguir para confirmações das informações.',
    },
  },
  modalConfirmation: {
    title: 'Confira seus dados',
    button: 'Confirmar',
    edit: 'Editar',
    labels: {
      personal: {
        ownerName: 'Nome completo',
        phone: 'Celular com whatsapp',
      },
      store: {
        document: 'CNPJ',
        tradingName: 'Nome da loja',
        visualAddress: 'Endereço',
        address2: 'Complemento',
        zip: 'CEP',
        number: 'Número',
        phone: 'Telefone da loja',
      },
      structure: {
        invoice: 'Cupom fiscal',
        refrigerators: 'Refrigeradores',
        coldChamber: 'Câmara fria',
        deliveryService: 'Entrega',
      },
      access: {
        email: 'E-mail',
      },
    },
    radioAnswers: {
      yes: 'Sim',
      no: 'Não',
    },
    acessibility: {
      backButton: 'Para preenchimento de informações de acesso.',
      confirmButton: 'Finalizar cadastro.',
      edit: {
        personal: 'Voltar para etapa de informações pessoais.',
        store: 'Voltar para etapa de informações da loja.',
        structure: 'Voltar para etapa de informações da estrutura da loja.',
        access: 'Voltar para etapa de informações de acesso.',
      },
    },
  },
  imgs: {
    arrowBack: 'Ícone da seta voltar',
    ze: 'Logo do Zé Delivery de bebidas',
    info: 'Ícone de informação',
    pin: 'Ícone de pin',
    phoneValidation:
      'Ilustração de uma mão segurando o celular, recebendo uma mensagem.',
  },
  header: {
    acessibility: {
      backButton: {
        0: 'Ir para página com informações sobre a parceria',
        1: 'Voltar para etapa de informações pessoais.',
        2: 'Voltar para etapa de informações da loja.',
        3: 'Voltar para etapa de informações da estrutura da loja.',
      },
    },
  },
  zenviaError: {
    title: 'Ops, algo deu errado',
    subtitle: 'Estamos com uma indisponibilidade no nosso sistema.',
    subtitle2: 'Aguarde e tente novamente mais tarde.',
    button: 'Voltar para home',
    acessibility: {
      button: 'Página com informação da parceria',
    },
  },
}

export default REGISTER_FORM
